export interface IBgxConfig {
  app: {
    id: string;
    name: string;
    version: string;
  };
  layout: {
    navbar: {
      mode: 'over' | 'side' | 'push';
    };
  };
}
